export default __webpack_public_path__ + "static/media/header.3f0e031f.png";